export default __webpack_public_path__ + "static/media/authentication3.b0b329b8.png";